import { Section } from 'custom-form-lib';

const START_FULL_STACK_SECTION = {
    contentId: 'Start',
    onInvalidMessage: 'Starten',
    onValidMessage: 'Starten',
    formGroupType: 'NoControl',
} as Section;

const INTRODUCTION_SECTION = {
    contentId: 'Introduction',
    formGroupType: 'TextInputControl',
    options: ['Dein Vorname', 'Dein Nachname'],
    formControlNames: ['firstName', 'lastName'],
    required: true,
    title: `
    <p class="text-[22px] font-bold font-figtree
      900:text-[28px]">
      <span class="text-orange">
        Schön, dass Du hier bist.
      </span> Bitte stelle dich kurz vor.
    </p>`,
} as Section;

const AGE_SECTION = {
    formGroupType: 'SingleChoiceControl',
    options: ['18-25', '26-35', '36-45', '46+'],
    formControlNames: ['age'],
    required: true,
    title: 'Wie alt bist du?',
} as Section;

const PROFESSION_SECTION = {
    formGroupType: 'SingleChoiceControl',
    options: [
        'Angestellt',
        'Selbstständig',
        // "Schüler / Schülerin",
        'Student / Studentin',
        // "Arbeitssuchend",
        'Bald Arbeitslos', // new
        'Arbeitslos (nicht beim Jobcenter/Agentur für Arbeit gemeldet)',
        'Arbeitslos (beim Jobcenter/Agentur für Arbeit gemeldet)',
        // "Sonstiges"
    ],
    formControlNames: ['profession'],
    required: true,
    title: 'Dein aktueller Berufsstand',
} as Section;

const EXPERIENCE_SECTION = {
    contentId: 'FullStackExperienceId',
    formGroupType: 'SingleChoiceControl',
    formControlNames: ['experience'],
    options: [
        'Ich habe noch nie eine Zeile Programm-Code geschrieben.',
        'Ich habe schon den ein oder anderen kleinen Kurs gemacht, aber ich habe dann irgendwann aufgehört weiterzumachen.',
        'Ich kann bereits die ein oder andere Programmiersprache ganz gut, bin aber noch lange kein Programmierer.',
        'Ich kenne mich mit Objektorientierter Programmierung aus und habe bereits meine eigene Websiten, Apps und Programme geschrieben.',
    ],
    title: 'Welche der folgenden Aussagen beschreibt Deine aktuelle Programmier-Erfahrung am besten?',
    required: true,
} as Section;

const DESIRES_SECTION = {
    formGroupType: 'MultipleChoiceControl',
    formControlNames: ['desires'],
    options: ['Webseiten', 'Apps', 'Spiele', 'Business Anwendungen', 'IT-Sicherheit'],
    title: 'Welche IT-Bereiche interessieren dich besonders?',
    required: true,
} as Section;

const STACKS_SECTION = {
    contentId: 'Stacks',
    formGroupType: 'LastChoiceSelectsAllControl',
    formControlNames: ['stacks'],
    options: ['Frontend', 'Backend', 'Fullstack'],
    title: 'Für welche Bereiche interessierst du dich?',
    required: true,
} as Section;

const WILL_SECTION = {
    onInvalidMessage: 'Bitte ausfüllen',
    formGroupType: 'TextAreaInputControl',
    formControlNames: ['will'],
    options: ['Gib hier deine Antwort ein...'],
    required: true,
    title: 'Warum willst Du Dich online zum IT-Spezialisten weiterbilden?',
    maxLength: [254],
} as Section;

const EMAIL_SECTION = {
    contentId: 'EmailAddress',
    onInvalidMessage: 'Bitte ausfüllen',
    formGroupType: 'EmailInputControl',
    formControlNames: ['email'],
    options: ['Deine E-Mail Adresse'],
    title: 'Deine E-Mail für die Terminbestätigung',
    required: true,
} as Section;

const PHONE_NUMBER_SECTION = {
    formGroupType: 'PhoneInputControl',
    formControlNames: ['phoneNumber'],
    options: ['012345678901'],
    preselectedValues: ['+49'],
    title: 'Unter welcher Telefonnummer können wir Dich für das Beratungsgespräch erreichen?',
    required: true,
} as Section;

const REACHABLE_SECTION = {
    formGroupType: 'SingleChoiceControl',
    formControlNames: ['reachable'],
    options: ['Morgens, zwischen 8-12 Uhr', 'Nachmittags, zwischen 13-17 Uhr', 'Abends, zwischen 17-20 Uhr'],
    title: 'Wann bist Du in der Regel am besten (telefonisch) erreichbar?',
    required: true,
} as Section;

const LEAD_SOURCE_SECTION = {
    formGroupType: 'MultipleChoiceControl',
    formControlNames: ['leadSource'],
    options: ['Suchmaschine (z.B. Google, Bing)', 'Youtube', 'Instagram', 'Facebook', 'TikTok', 'mein NOW', 'Podcast'],
    title: 'Wie bist du auf uns aufmerksam geworden?',
    required: true,
    optionalInput: 'Sonstiges',
    onValidMessage: 'Übermitteln',
} as Section;

/**
 * @deprecated
 */

// biome-ignore lint/correctness/noUnusedVariables: <explanation>
const CURRENT_SITUATION_SECTION = {
    formGroupType: 'SingleChoiceControl',
    formControlNames: ['situation'],
    options: [
        'Ich habe die finanzielle Möglichkeit, um in meine Weiterbildung zu investieren.',
        'Ich habe im Notfall Zugang zu finanziellen Ressourcen, um in meine Weiterbildung zu investieren.',
        'Ich habe nicht die finanziellen Möglichkeiten, um in meine berufliche Zukunft zu investieren und habe dies auch nicht vor.',
    ],
    title: 'Beschreibe bitte Deine aktuelle Situation',
    required: true,
} as Section;

export const FULL_STACK_SECTIONS = [
    START_FULL_STACK_SECTION,
    INTRODUCTION_SECTION,
    AGE_SECTION,
    PROFESSION_SECTION,
    EXPERIENCE_SECTION,
    DESIRES_SECTION,
    STACKS_SECTION,
    WILL_SECTION,
    EMAIL_SECTION,
    PHONE_NUMBER_SECTION,
    REACHABLE_SECTION,
    LEAD_SOURCE_SECTION,
];
